module.exports = __webpack_public_path__ + "img/675.a038e908.jpg";